const getInitialsOfName = (name) => {
  const parts = name?.trim()?.split(/\s+/)?.filter(Boolean) ?? [];
  if (!parts.length) return "";
  if (parts.length === 1) {
    return parts[0]?.charAt(0)?.toUpperCase() ?? "";
  }
  return `${parts[0]?.charAt(0) ?? ""}${parts[parts.length - 1]?.charAt(0) ?? ""}`.toUpperCase();
};

export default getInitialsOfName;
